import ApplicationController from '../../frontend/support/application_controller'
import Spinner               from '../../frontend/support/spinner'

export default class extends ApplicationController {

  static targets = [
    'button'
  ]

  static values = {
    timeout: Number
  }

  static classes = [
    'loading'
  ]

  initialize() {
    this.spinner = new Spinner(this.element, {
      buttonElement: this.buttonElement,
      loadingClass:  this.loadingClass,
      timeout:       this.timeoutValue,
      onLoading:     () => {
        this.dispatch('loading', { bubbles: true, prefix: 'spinner' })
      },
      onLoaded:      () => {
        this.dispatch('loaded', { bubbles: true, prefix: 'spinner' })
      }
    })
  }

  disconnect() {
    this.spinner?.destroy()
    this.spinner = null
  }

  // ==== Controllers

  // ==== Actions

  loading(event) {
    this.spinner.loading(event)
  }

  loaded() {
    this.spinner.loaded()
  }

  // ==== Getters

  /**
   * @field {HTMLElement}
  */
  get buttonElement() {
    if (this.hasButtonTarget) return this.buttonTarget

    return this.element
  }

}
